import React from "react";

const CONFIG = {
  ready: { label: "Ready", bg: "#ECFDF5", text: "#047857", border: "#A7F3D0", dot: "#10B981" },
  needs_photos: { label: "Needs Photos", bg: "#FEF3C7", text: "#B45309", border: "#FDE68A", dot: "#F59E0B" },
  needs_details: { label: "Needs Details", bg: "#FEF2F2", text: "#B91C1C", border: "#FECACA", dot: "#EF4444" },
};

export default function StatusBadge({ status, testid }) {
  const c = CONFIG[status] || CONFIG.needs_details;
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold border"
      style={{ backgroundColor: c.bg, color: c.text, borderColor: c.border }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: c.dot }} />
      {c.label}
    </span>
  );
}
